"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBundleDiscount = function (discount) {
    var isCartDiscount = discount.applyType === 'cart';
    if (!isCartDiscount)
        return false;
    var products = discount.products;
    return (products.length > 0 &&
        products.every(function (product) { return product.type === 'include'; }));
};
//# sourceMappingURL=utilities.js.map